import { Link } from "react-router-dom";
import "./BlockHeader.scss";

export default function BlockHeader(props){
    return(
        <div className={`block-header ${props.link && '-has-link'}`}>
            { props.icon && <span className="icon">{props.icon}</span> }
            <h1 className="h1">{props.title}</h1>
            <div className="desc">{props.desc}</div>
            { 
                props.link && typeof props.link == 'string' &&
                <a href={props.link} className="block-link">
                    {props.linkText ? props.linkText : 'View All'}
                </a> 
            }
            { 
                props.link && typeof props.link == 'object' &&
                <Link  className="block-link" to={props.link}>{props.link_text ? props.link_text : 'View All'}</Link>
            }
        </div>
    )
}